import { render, staticRenderFns } from "./DeleteFacebookInfo.vue?vue&type=template&id=89fb3d6c&scoped=true"
import script from "./DeleteFacebookInfo.vue?vue&type=script&lang=js"
export * from "./DeleteFacebookInfo.vue?vue&type=script&lang=js"
import style0 from "./DeleteFacebookInfo.vue?vue&type=style&index=0&id=89fb3d6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fb3d6c",
  null
  
)

export default component.exports